import React, { useMemo } from 'react';
import { Droppable } from 'react-beautiful-dnd';
import orderBy from 'lodash/orderBy';
import classNames from 'classnames';

import ErrorLayout from 'components/ErrorLayout';
import LibraryClassesDragDrop from '../LibraryClassesDragDrop';
import LibraryClassRow from '../LibraryClassRow';
import styles from './LibraryClassList.module.scss';
import Table from 'components/Table';
import TableBody from 'components/TableBody';
import TableCell from 'components/TableCell';
import TableHead from 'components/TableHead';
import TableRow from 'components/TableRow';

// TODO Add proper icons for delete and move
function LibraryClassList({ classes }) {
  const orderedClasses = useMemo(() => {
    return orderBy(classes, ['order'], ['asc']);
  }, [classes]);

  if (orderedClasses.length > 0) {
    return (
      <LibraryClassesDragDrop orderedClasses={orderedClasses}>
        {({ isMoving }) => (
          <Table className={styles.table}>
            <TableHead>
              <TableRow>
                <TableCell>Class Name</TableCell>
                <TableCell>Type</TableCell>
                <TableCell>Junction</TableCell>
                <TableCell>Delete Class</TableCell>
                <TableCell></TableCell>
              </TableRow>
            </TableHead>
            <Droppable droppableId="library-classes">
              {({ innerRef, droppableProps, placeholder: dropPlaceholder }) => (
                <TableBody
                  ref={innerRef}
                  className={classNames({ [styles.disabled]: isMoving })}
                  {...droppableProps}
                >
                  {orderedClasses.map((cls, index) => (
                    <LibraryClassRow
                      key={cls.id}
                      cls={cls}
                      index={index}
                    />
                  ))}
                  {dropPlaceholder}
                </TableBody>
              )}
            </Droppable>
          </Table>
        )}
      </LibraryClassesDragDrop>
    );
  } else {
    return <ErrorLayout message="No classes added to this library yet!" />;
  }
}

export default LibraryClassList;
